module.exports = __webpack_public_path__ + "media/images/lb/204-636e9a5d378d6204b501a491d4562ade.svg";